// Tab-scoped so separate email links cannot overwrite another tab's destination.
const LOGIN_RETURN_URL_KEY = 'wallit.loginReturnUrl';

export function normalizeLoginReturnUrl(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')
    || /[\\\x00-\x20]/.test(value)) return null;
  try {
    const path = decodeURIComponent(value.split(/[?#]/)[0]);
    if (path.startsWith('//') || /[\\\x00-\x20]/.test(path)) return null;
    const url = new URL(value, 'https://wallit.invalid');
    if (url.origin !== 'https://wallit.invalid'
      || /^\/(?:signin|login|token|handoff|auth|federated-auth-callback|signout|logout)(?:[\/;]|$)/i.test(decodeURIComponent(url.pathname))) return null;
    return value;
  } catch {
    return null;
  }
}

export function getLoginReturnUrl(): string | null {
  return normalizeLoginReturnUrl(window.sessionStorage.getItem(LOGIN_RETURN_URL_KEY));
}

export function setLoginReturnUrl(value: unknown): void {
  const url = normalizeLoginReturnUrl(value);
  if (url) window.sessionStorage.setItem(LOGIN_RETURN_URL_KEY, url);
  else window.sessionStorage.removeItem(LOGIN_RETURN_URL_KEY);
}
